{
  "title": "Журнал",
  "description": "Усі оцінені роботи класу в одній таблиці — тести, домашні завдання та ваші власні стовпці.",
  "class": "Клас",
  "selectClass": "Оберіть клас",
  "noClasses": {
    "title": "Немає класів для показу",
    "teacherText": "Ви поки не ведете жодного класу — журнал оцінок ведеться по класах.",
    "adminText": "У школі ще немає класів. Журнал оцінок наповниться, щойно з’явиться перший.",
    "action": "До класів"
  },
  "from": "Від",
  "to": "До",
  "clearRange": "Очистити дати",
  "pupil": "Учень",
  "total": "Разом",
  "loadFailed": "Не вдалося завантажити журнал.",
  "empty": {
    "items": "У цьому класі ще немає оцінених робіт. Призначте тест, опублікуйте домашнє завдання або додайте стовпець.",
    "pupils": "До цього класу ще нікого не зараховано.",
    "filteredItems": "У цей проміжок дат не потрапила жодна оцінена робота. Очистіть дати, щоб побачити всі роботи."
  },
  "kinds": {
    "test": "Тест",
    "homework": "Домашнє",
    "project": "Проєкт",
    "manual": "Стовпець"
  },
  "cell": {
    "graded": "Оцінено",
    "pending": "Очікує оцінювання",
    "missing": "Нічого не здано",
    "notApplicable": "Не в цій команді",
    "notApplicableShort": "—",
    "missingShort": "×",
    "pendingShort": "·",
    "label": "{{pupil}} — {{item}}",
    "saving": "Збереження",
    "saveFailed": "Не вдалося зберегти оцінку."
  },
  "totals": {
    "label": "{{earned}} з {{possible}}",
    "percent": "{{percent}}%"
  },
  "scale": {
    "points": "Бали",
    "ua_12": "12-бальна шкала"
  },
  "maxScore": "макс. {{max}}",
  "export": {
    "csv": "Експорт CSV",
    "xlsx": "Експорт XLSX",
    "started": "Файл завантажується.",
    "failed": "Не вдалося завантажити файл."
  },
  "column": {
    "add": "Додати стовпець",
    "addTitle": "Новий стовпець оцінок",
    "addDescription": "Ваш власний стовпець — усна відповідь, робота на уроці, проєкт. Оцінки зберігаються в балах.",
    "editTitle": "Редагувати стовпець",
    "menu": "Дії зі стовпцем",
    "edit": "Редагувати",
    "archive": "Архівувати",
    "fields": {
      "title": "Назва",
      "titlePlaceholder": "Усна відповідь",
      "maxScore": "Максимальний бал",
      "date": "Дата",
      "kind": "Вид роботи"
    },
    "validation": {
      "titleRequired": "Вкажіть назву стовпця.",
      "maxScoreRequired": "Вкажіть максимальний бал.",
      "maxScorePositive": "Максимальний бал має бути більшим за 0.",
      "dateRequired": "Оберіть дату."
    },
    "created": "Стовпець додано.",
    "updated": "Стовпець оновлено.",
    "archiveTitle": "Архівувати «{{title}}»?",
    "archiveDescription": "Стовпець зникне з журналу, а вже виставлені оцінки залишаться в історії.",
    "archived": "Стовпець заархівовано.",
    "save": "Зберегти"
  },
  "openSource": "Відкрити сторінку, де оцінюється цей стовпець"
}
